export default {
    index(data) {
		return 'hahaha'
	},
}
